import { createGenericDispatcher } from '../../../action/action-dispatcher-factory';
import { addNotificationAction } from '../../../action/notifications/notifications';

import * as Api from '../../../api/api';

export const scheduleSurveyResponseMessage = (surveyResponseId: number) =>
  createGenericDispatcher<SurveyResponse>({
    name: 'SCHEDULE_SURVEY_RESPONSE_MESSAGE',
    loadFunction: () => Api.post(`/survey-responses/${surveyResponseId}/schedule-message`),
    args: { surveyResponseId },
    onSuccess: (dispatch: Function) => {
      dispatch(
        addNotificationAction({
          key: `retry-survey-notification-${surveyResponseId}`,
          message: 'Message was sent successfully',
        }),
      );
    },
  });
